import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconProgressArc: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconProgressArc"><Path d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 12L17.9102 15.751C18.5819 14.6925 18.9567 13.4727 18.9961 12.2197C19.0354 10.9668 18.7377 9.72645 18.1338 8.62793C17.5299 7.52939 16.6425 6.61275 15.5635 5.97461C14.4844 5.33646 13.2536 5 12 5V12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconProgressArc;
